import { t } from 'i18next';
import styled from "styled-components";
import { FAN_BUDDY_MBTI } from "../../utils/FanBuddyHelper";

// const Card = styled.div`
//   max-width: 177px;
//   border-radius: 22px;
//   border: 1px outset rgba(0, 0, 0, 0.1);
//   background: ${props => `linear-gradient(180deg, rgba(255, 255, 255, 0.70) 0%, #FFF 5.61%, rgba(255, 255, 255, 0.30) 19.79%, #FFF 36%, rgba(255, 255, 255, 0.48) 70%, #FFF 100%), linear-gradient(134deg, rgba(${props.backgroundPrimaryColor},1) 9.43%, rgba(255, 255, 255, 0.90) 45.41%, rgba(${props.backgroundSecondaryColor},1) 81.4%)`};
//   box-shadow: 0px -6px 40px 0px rgba(61, 250, 165, 0.20), 0px 6px 40px 0px rgba(42, 102, 246, 0.25);
//   animation: shadowPulse 3s infinite, float 2.5s ease-in-out infinite;
//   @keyframes shadowPulse {
//     0% {
//       ${props => `box-shadow: 0px -6px 40px 0px rgba(${props.backgroundPrimaryColor}, 0.20), 0px 6px 40px 0px rgba(${props.backgroundSecondaryColor}, 0.25)`};
//     }
//     50% {
//       ${props => `box-shadow: 0px -12px 80px 0px rgba(${props.backgroundPrimaryColor}, 0.40), 0px 12px 80px 0px rgba(${props.backgroundSecondaryColor}, 0.35)`};
//     }
//     100% {
//       ${props => `box-shadow: 0px -6px 40px 0px rgba(${props.backgroundPrimaryColor}, 0.20), 0px 6px 40px 0px rgba(${props.backgroundSecondaryColor}, 0.25)`};
//     }
//   }

//   @keyframes float {
//     0% {
//       transform: translateY(0px);
//     }
//     50% {
//       transform: translateY(-3px);
//     }
//     100% {
//       transform: translateY(0px);
//     }
//   }
// `;

const Card = styled.div`
  max-width: 177px;
  border-radius: 22px;
  border: 1px outset rgba(0, 0, 0, 0.1);
  background: ${({ isDarkMode, ...props }) =>
    isDarkMode
      ? `
      linear-gradient(
        180deg,
        rgba(0,0,0,0.70) 0%,
        #000 5.61%,
        rgba(0,0,0,0.30) 19.79%,
        #000 36%,
        rgba(0,0,0,0.48) 70%,
        #000 100%
      ),
      linear-gradient(
        134deg,
        rgba(${props.backgroundPrimaryColor},0.18) 9.43%,
        rgba(0,0,0,0.7) 45.41%,
        rgba(${props.backgroundSecondaryColor},0.8) 90%
      )
    `
      : `
      linear-gradient(
        180deg,
        rgba(255,255,255,0.70) 0%,
        #FFF 5.61%,
        rgba(255,255,255,0.30) 19.79%,
        #FFF 36%,
        rgba(255,255,255,0.48) 70%,
        #FFF 100%
      ),
      linear-gradient(
        134deg,
        rgba(${props.backgroundPrimaryColor},1) 9.43%,
        rgba(255,255,255,0.90) 45.41%,
        rgba(${props.backgroundSecondaryColor},0.35) 81.4%
      )
    `};
  animation: shadowPulse 3s infinite, float 2.5s ease-in-out infinite;
  @keyframes shadowPulse {
    0% {
      ${(props) =>
        `box-shadow: 0px -6px 40px 0px rgba(${props.backgroundPrimaryColor}, 0.20), 0px 6px 40px 0px rgba(${props.backgroundSecondaryColor}, 0.25)`};
    }
    50% {
      ${(props) =>
        `box-shadow: 0px -12px 80px 0px rgba(${props.backgroundPrimaryColor}, 0.40), 0px 12px 80px 0px rgba(${props.backgroundSecondaryColor}, 0.35)`};
    }
    100% {
      ${(props) =>
        `box-shadow: 0px -6px 40px 0px rgba(${props.backgroundPrimaryColor}, 0.20), 0px 6px 40px 0px rgba(${props.backgroundSecondaryColor}, 0.25)`};
    }
  }
  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-3px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;

// const MBTIImage = styled.div`
//   width: 93px;
//   height: 93px;
//   -webkit-mask-image: ${props => `url(/assets/icons/mbti/${props.mbti}.png`});
//   -webkit-mask-composite: source-in;
//   mask-composite: intersect;
//   mask-size: cover;
//   background: ${props => `linear-gradient(-135deg, rgba(${props.textPrimaryColor}, 0.7), rgba(${props.textSecondaryColor}, 0.7))`};
// `

const MBTITitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  background: ${props => `linear-gradient(90deg, rgba(${props.textPrimaryColor},1) 0%, rgba(${props.textSecondaryColor},1) 100%)`};
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
	word-break: keep-all;
`

// const MBTIRecap = styled.div`
//   padding-top: 10px;
//   font-size: 13px;
//   font-weight: 400;
//   line-height: 16px;
//   text-align: center;
//   color: ${LightColors.textmainlv2};
// 	word-break: keep-all;
// `

export const MBTICard = ({ mbti, isMine = true, isDarkMode = false}) => {
  return (
    <Card
      isDarkMode={isDarkMode}
      backgroundPrimaryColor={FAN_BUDDY_MBTI[mbti].backgroundColor.primary}
      backgroundSecondaryColor={FAN_BUDDY_MBTI[mbti].backgroundColor.secondary}
      textPrimaryColor={FAN_BUDDY_MBTI[mbti].textColor.primary}
      textSecondaryColor={FAN_BUDDY_MBTI[mbti].textColor.secondary}
    >
      <div className="flex flex-col items-center" style={{ padding: '0px 20px' }}>
        <div className="text-[11px] font-semibold leading-[13px] text-center mt-[31px] mb-[13px] text-main-light-4 dark:text-main-dark-4">
          {isMine ? t('MBTICard.myCard') : t('MBTICard.otherCard')}
        </div>
        {/* <MBTIImage
          mbti={mbti}
          textPrimaryColor={FAN_BUDDY_MBTI[mbti].textColor.primary}
          textSecondaryColor={FAN_BUDDY_MBTI[mbti].textColor.secondary}
        /> */}
        <img src={`/assets/icons/mbti/${mbti}.png`} alt={mbti} className="w-[93px] h-[93px]"/>
        {/* <MBTIImage src={`/assets/icons/mbti/${mbti}.png`} alt={mbti}/> */}
        {/* </ImageContainer> */}
        <div style={{ height: '86px', marginBottom: '13px', alignContent: 'center' }}>
          <MBTITitle
            textPrimaryColor={FAN_BUDDY_MBTI[mbti].textColor.primary}
            textSecondaryColor={FAN_BUDDY_MBTI[mbti].textColor.secondary}
          >
            {FAN_BUDDY_MBTI[mbti].name}
          </MBTITitle>
          <div className="text-[13px] font-normal leading-[16px] text-center pt-[10px] text-main-light-2 dark:text-main-dark-2 word-break: keep-all;">
            {FAN_BUDDY_MBTI[mbti].recap}
          </div>
        </div>
      </div>
    </Card>
  );
}
